module.exports = __webpack_public_path__ + "static/media/icon_calender_arrow_left.d4c09e5c.svg";